import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const validationSchema = (t: TFunction) =>
  Yup.object().shape({
    clockInAt: Yup.date().required(t('valid_err_required')),

    clockOutAt: Yup.date()
      .required(t('valid_err_required'))
      .test(
        'is-after-clockin',
        t('ClockOutMustBeAfterClockIn'),
        function (value) {
          const { clockInAt } = this.parent;

          if (!clockInAt || !value) return true;

          return value >= clockInAt;
        }
      ),
    note: Yup.string()
      .required(t('valid_err_required'))
      .trim()
      .max(100, t('CannotExceedCharacters', { char: 255 })),
  });

export type AdjustPointsValidationSchemaType = ReturnType<
  typeof validationSchema
>;
